class GtmScriptAPI {
    constructor(config = {}) {
        /**
         * Default config
         */
        this._config = config
        /**
         * Defines if the component is ready
         */
        this._isReady = false

        /**
         * Initializes component
         */
        this.initialize = () => (this._isReady = true)
    }
}

export default GtmScriptAPI
